"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ChevronLeft_1 = require("@material-ui/icons/ChevronLeft");
var ChevronRight_1 = require("@material-ui/icons/ChevronRight");
var FieldCoreBase_1 = require("@react-form-fields/core/components/FieldCoreBase");
var ValidationContextRegister_1 = require("@react-form-fields/core/components/ValidationContextRegister");
var format_1 = require("date-fns/format");
var parse_1 = require("date-fns/parse");
var DatePicker_1 = require("material-ui-pickers/DatePicker");
var React = require("react");
var config_1 = require("../config");
var FieldDate = /** @class */ (function (_super) {
    tslib_1.__extends(FieldDate, _super);
    function FieldDate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.removeTime = function (date) {
            if (!date || _this.props.keepTime)
                return date;
            return parse_1.default(format_1.default(date, 'yyyy-MM-dd'), 'yyyy-MM-dd', new Date(), {
                locale: config_1.getConfig().dateLocale
            });
        };
        _this.onChange = function (date) {
            config_1.getConfig().validationOn === 'onChange' && _this.setState({ showError: true });
            _this.props.onChange(_this.removeTime(date));
        };
        _this.onBlur = function (e) {
            _this.props.onBlur && _this.props.onBlur(e);
            config_1.getConfig().validationOn === 'onBlur' && _this.setState({ showError: true });
        };
        return _this;
    }
    FieldDate.prototype.render = function () {
        var _a = this.props, value = _a.value, label = _a.label, format = _a.format, helperText = _a.helperText, validation = _a.validation, validationContext = _a.validationContext, onBlur = _a.onBlur, mask = _a.mask, extraProps = tslib_1.__rest(_a, ["value", "label", "format", "helperText", "validation", "validationContext", "onBlur", "mask"]);
        return (React.createElement(React.Fragment, null,
            React.createElement(ValidationContextRegister_1.default, { field: this }),
            React.createElement(DatePicker_1.default, tslib_1.__assign({ clearable: true, clearLabel: config_1.getConfig().dateLabels.clear, okLabel: config_1.getConfig().dateLabels.ok, cancelLabel: config_1.getConfig().dateLabels.cancel, fullWidth: true, margin: 'normal', leftArrowIcon: React.createElement(ChevronLeft_1.default, null), rightArrowIcon: React.createElement(ChevronRight_1.default, null) }, extraProps, { label: label, value: value || null, format: format || config_1.getConfig().dateFormat, error: !!this.errorMessage, helperText: this.errorMessage || helperText, required: this.isRequired, onChange: this.onChange, onBlur: this.onBlur }))));
    };
    return FieldDate;
}(FieldCoreBase_1.default));
exports.default = FieldDate;
//# sourceMappingURL=Date.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-form-fields/material-ui/components/Date.js
// module id = 476
// module chunks = 58